import React from 'react';
import LargeButton from '../../shared/components/LargeButton';
import { useNavigate } from 'react-router-dom';
import { Page } from '../../layout';
import PrivilegeNames from '../../../constants/privilegeNames';
import { useReactiveVar } from '@apollo/client';
import { userInfo } from '../../../apollo/cache';
import { Breadcrumb } from '../../shared/components/breadcrumb/Breadcrumb';
import { getAdjustedBreadcrumbPathItems } from '../../shared/services/breadcrumbService';
import {
  getExecutiveSummaryUrl,
  getUnitSearchForOrgReports
} from '@shared/services/getUnitSearchPageUrlService';

const pageTitle = 'Organization Reports';
const breadcrumbPathItems = [
  { name: 'Data Reports', url: '/data-reports' },
  {
    name: pageTitle,
    url: '/data-reports/organization-reports'
  }
];

const OrganizationReportsNavigationPage = () => {
  const currentUserInfo = useReactiveVar(userInfo);
  const privileges = currentUserInfo.Privileges;
  const roleId = currentUserInfo.SystemRole.Id;
  const orgUnitId = currentUserInfo.LicensedOrgUnitId;

  const adjustedBreadcrumbPathItems = getAdjustedBreadcrumbPathItems(breadcrumbPathItems, roleId);

  const navigate = useNavigate();

  return (
    <Page title={pageTitle}>
      <Breadcrumb pathItems={adjustedBreadcrumbPathItems} />

      <div className='reports-page-navigation'>
        <h2>Which Organization Report would you like to view?</h2>
        <div className='reports-page-navigation__controls'>
          {privileges?.includes(PrivilegeNames.OrganizationReports_ExecutiveSummary) && (
            <LargeButton
              onClick={() => navigate(getExecutiveSummaryUrl(privileges))}
              subText='See your organizations results'>
              Executive Summary
            </LargeButton>
          )}

          {privileges?.includes(PrivilegeNames.OrganizationReports_UnitReports) && (
            <LargeButton
              onClick={() => navigate(getUnitSearchForOrgReports(privileges, orgUnitId))}
              subText='See your units results'>
              Unit Report(s)
            </LargeButton>
          )}
        </div>
      </div>
    </Page>
  );
};

export default OrganizationReportsNavigationPage;
